// extracted by mini-css-extract-plugin
export default {"articleLink":"style_articleLink__uM1yK","articleLink_dark":"style_articleLink_dark__V8PXi"};